export default __webpack_public_path__ + "static/media/check-light.66bfd9d3.svg";